module.exports = __webpack_public_path__ + "static/media/8.8016b695.svg";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/newWeatherIcons/8.svg
// module id = 2840
// module chunks = 3